import * as server from "@/utils/http"

export const _get = params => server.get("/lis-option/get", params);

export const _save = params => server.postfrom(params.id ? "/lis-option/update" : "/lis-option/save", params);

export const _updateOptionStatus = params => server.get("/lis-option/updateStatus", params);


